// plugins/clarity.js
import Clarity from '@microsoft/clarity'

const VueClarity = {
  install(Vue, { projectId } = {}) {
    if (!projectId) throw new Error('No Microsoft Clarity projectId specified.')
    // Initialize once
    Clarity.init(projectId)

    // Expose the SDK so you can call in Options/Composition APIs
    Vue.prototype.$clarity = Clarity

    // Optional ergonomic helpers (so code reads like your Mouseflow wrapper)
    Vue.prototype.$claritySet = (key, value) => Clarity.setTag(key, value)
    Vue.prototype.$clarityEvent = (name) => Clarity.event(name)
    Vue.prototype.$clarityIdentify = (id, sessionId, pageId, friendly) =>
      Clarity.identify(id, sessionId, pageId, friendly)
    Vue.prototype.$clarityConsent = (consented = true) => Clarity.consent(consented)
    Vue.prototype.$clarityUpgrade = (reason) => Clarity.upgrade(reason)
  }
}

export default VueClarity
